module.exports = __webpack_public_path__ + "media/1.36ff0c06.mp3";